import React from 'react';
import { Button, Divider } from 'antd';
import styles from './index.module.scss';

const preventBlur = (event) => event.preventDefault();

const OwnersDropdown = ({ menu, onAdd, addText = 'Добавить жильца' }) => (
  <div>
    {menu}
    <Divider className={styles.divider} />
    <div className={styles.footer} onMouseDown={preventBlur}>
      <Button type="link" icon="plus" className={styles.addBtn} onClick={onAdd}>
        {addText}
      </Button>
    </div>
  </div>
);

export default OwnersDropdown;
